// i18n area 'auth' — locale hy-AM (task #171, onda 5): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/auth.hy-AM.meta.json.
import type { enUS } from './auth'

export const hyAM: typeof enUS = {
  login: {
    welcome: 'Trantor TVirt v6',
    subtitle: 'Մուտք գործեք ձեր հաշիվ',
    username: 'Օգտանուն',
    usernamePlaceholder: 'Մուտքագրեք օգտանունը',
    usernameHint: 'Օգտագործեք օգտատեր@դոմեն ձևը՝ դիրեկտորիայի ռեալմում նույնականանալու համար',
    continue: 'Շարունակել',
    changeUser: 'Դուք չե՞ք',
    password: 'Գաղտնաբառ',
    forgotPassword: 'Մոռացե՞լ եք գաղտնաբառը',
    submit: 'Մուտք',
    otp: 'Միանգամյա կոդ',
    otpSubtitle: 'Մուտքագրեք ձեր նույնականացնողի կոդը',
    otpHint: 'Վեց թվանշան նույնականացնող հավելվածից, կամ վերականգնման կոդերից մեկը',
    otpSubmit: 'Ստուգել',
    invalidCredentials: 'Օգտանունը կամ գաղտնաբառը սխալ է',
    tooManyAttempts: 'Չափազանց շատ փորձեր — մի պահ սպասեք և կրկին փորձեք',
    realmUnavailable: 'Ռեալմն այս պահին չի կարող ստուգել հավատարմագրերը — կլաստերի կոնֆիգուրացիայի պահոցն անհասանելի է։ Մուտք գործեք որպես լոկալ օգտատեր (break-glass)։',
    genericError: 'Մուտքը չհաջողվեց — TVirt բեքենդը հասանելի՞ է'
  },
  user: {
    logout: 'Դուրս գալ',
    password: {
      menu: 'Փոխել գաղտնաբառը',
      title: 'Փոխեք ձեր գաղտնաբառը',
      current: 'Ընթացիկ գաղտնաբառ',
      new: 'Նոր գաղտնաբառ',
      confirm: 'Հաստատեք նոր գաղտնաբառը',
      mismatch: 'Գաղտնաբառերը չեն համընկնում',
      error: 'Չհաջողվեց փոխել գաղտնաբառը',
      forcedTitle: 'Շարունակելու համար փոխեք գաղտնաբառը',
      forcedHint: 'Այս գաղտնաբառը սահմանել է ադմինիստրատորը, և մուտքից առաջ այն պետք է փոխարինվի։',
      forcedSubmit: 'Փոխել և մտնել'
    },
    mfa: {
      title: 'Երկգործոն նույնականացում',
      subtitle: 'Երկրորդ գործոն, որը պահանջվում է ամեն մուտքի ժամանակ',
      loadError: 'Չհաջողվեց բեռնել երկրորդ գործոնի վիճակը',
      enrolled: 'Ակտիվ',
      notEnrolled: 'Ակտիվ չէ',
      enrolledAt: 'Ակտիվացվել է',
      codesRemaining: 'Մնացած վերականգնման կոդեր',
      requiredHint:
        'Ադմինիստրատորը պահանջում է երկրորդ գործոն այս հաշվի վրա. կարգավորեք այն հիմա — մինչ այդ կարող եք մուտք գործել, բայց ոչ շատ ավելին։',
      enroll: 'Կարգավորել',
      enrollTitle: 'Կարգավորել երկգործոն նույնականացումը',
      enrollHint: 'Սկանավորեք այս կոդը նույնականացնող հավելվածով, ապա հաստատելու համար մուտքագրեք նրա ցույց տված կոդը։',
      secretHint: 'Չե՞ք կարողանում սկանավորել։ Փոխարենը մուտքագրեք այս գաղտնիքը հավելվածում՝',
      code: 'Կոդը հավելվածից',
      confirm: 'Հաստատել',
      startError: 'Չհաջողվեց սկսել կարգավորումը',
      confirmError: 'Չհաջողվեց հաստատել կարգավորումը',
      codesTitle: 'Ձեր վերականգնման կոդերը',
      codesWarning:
        'Այս կոդերը ցուցադրվում են միայն մեկ անգամ։ Պահպանեք դրանք հիմա. յուրաքանչյուրը թույլ է տալիս մուտք գործել, երբ նույնականացնողն անհասանելի է, և գործում է միայն մեկ անգամ։',
      codesAck: 'Ես պահպանել եմ վերականգնման կոդերը',
      codesDone: 'Պատրաստ է',
      copy: 'Պատճենել',
      copied: 'Պատճենված է',
      download: 'Ներբեռնել',
      regenerate: 'Նոր վերականգնման կոդեր',
      regenerateTitle: 'Վերագեներացնել վերականգնման կոդերը',
      regenerateHint: 'Մինչ այժմ տրված բոլոր կոդերը դադարում են գործել նոր հավաքածուի գեներացման պահին։',
      regenerateConfirm: 'Վերագեներացնել',
      regenerateError: 'Չհաջողվեց վերագեներացնել վերականգնման կոդերը',
      remove: 'Հեռացնել',
      removeTitle: 'Հեռացնել երկրորդ գործոնը',
      removeConfirm: 'Հեռացնել',
      removeHint: 'Հաշիվը վերադառնում է միայն գաղտնաբառին։ Կարող եք ցանկացած պահի նորից կարգավորել երկրորդ գործոնը։',
      removeRequiredHint:
        'Ադմինիստրատորը պահանջում է երկրորդ գործոն այս հաշվի վրա, ուստի սերվերը կմերժի հեռացումը — նախ խնդրեք նրան հանել պահանջը։',
      removeError: 'Չհաջողվեց հեռացնել երկրորդ գործոնը'
    },
    profile: {
      menu: 'Անցնել իմ պրոֆիլ',
      sessions: 'Ակտիվ սեանսներ',
      sessionsHint: 'Ձեր բաց սեանսներն այս հանգույցի վրա',
      sessionsEmpty: 'Ակտիվ սեանսներ չկան',
      sessionCreated: 'Մուտք է գործվել',
      sessionExpires: 'Ժամկետը լրանում է',
      revoke: 'Ետ կանչել սեանսը',
      revokeError: 'Չհաջողվեց ետ կանչել սեանսը',
      loadError: 'Չհաջողվեց բեռնել սեանսները'
    }
  }
}
